import { render } from "./PeopleAsadi.vue?vue&type=template&id=701d11d0"
import script from "./PeopleAsadi.vue?vue&type=script&lang=js"
export * from "./PeopleAsadi.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__